import { COLORS, DSModal, DSTooltip } from '@repo/design-system/index'
import { QIcon_check_default, QIcon_question_outline, QIcon_status_done, QIcon_status_expired } from '@repo/icons/index'
import classNames from 'classnames'
import React from 'react'
import { IWeeklyLessonProgress } from '../../model/credit.interface'
import useIsMobile from '../../modules/hooks/common/useIsMobile'
import { n_weekly, s_common, s_modal_weekly } from '../../modules/i18n/strings/auto/wording'
import useTranslation from '../../modules/i18n/useTranslation'
import Badge from '../common/Badge'
import CreditBadge from '../common/buttons/CreditBadge'

interface IWeeklyLessonProgressPopup {
  data: IWeeklyLessonProgress
  showPopup: boolean
  setShowPopup: React.Dispatch<React.SetStateAction<boolean>>
}
const WeeklyLessonProgressPopup: React.FC<IWeeklyLessonProgressPopup> = ({ data, showPopup, setShowPopup }) => {
  const { t } = useTranslation()
  const isMobile = useIsMobile()
  const getStatus = (achieved, achievementDetail) => {
    if (achieved && achievementDetail == 'graced') {
      return <div className="Caption-12Bd text-gray-600">{t(n_weekly.freeze.title)}</div>
    }
    if (achieved) {
      return (
        <div>
          <QIcon_status_done width={24} height={24} color="#503CC8" />
        </div>
      )
    }
    if (!achieved && achievementDetail == 'deducted') {
      return (
        <div>
          <QIcon_status_expired width={24} height={24} color="#503CC8" />
        </div>
      )
    }

    return (
      <div>
        <QIcon_check_default width={24} height={24} color={COLORS.GRAY200} />
      </div>
    )
    // switch (status) {
    //   case 'done':
    //     return (

    //     )
    //   case 'failed':
    //     return (
    //       <div>
    //         <QIcon_status_expired width={24} height={24} />
    //       </div>
    //     )
    //   case 'recovered':
    //     return <div className="text-[12px] font-bold text-gray-600">{t(s_modal_weekly.msg)}</div>
    //   case 'undetermined':
    //     return (
    //       <div>
    //         <QIcon_check_default width={24} height={24} color={COLORS.GRAY200} />
    //       </div>
    //     )
    //   default:
    //     return (
    //       <div>
    //         <QIcon_check_default width={24} height={24} color={COLORS.GRAY200} />
    //       </div>
    //     )
    // }
  }

  return (
    <>
      <DSModal
        id="XLNoButtonScrollPopup"
        isOpen={showPopup}
        setIsOpen={setShowPopup}
        size={isMobile ? 'sm' : 'xl'}
        closeButton={true}
        closeOnDim={true}
      >
        <DSModal.Title>
          <div className="flex space-x-[7px]">
            <CreditBadge duration={data.duration} clx="h-[21px] text-[12px] leading-[20px] font-bold" />
            <Badge ml8 dangerLight clx="flex items-center text-red-600 text-[12px] font-bold">
              {t(s_common.label_weekly)}
            </Badge>
          </div>
          <div className="mt-[2px]">{data.productLineName}</div>
          <div className="Body2-14Md mt-[24px] flex gap-x-[4px]">
            <div>{t(n_weekly.freeze.title)}</div>
            <DSTooltip
              place="top"
              isMultiline={true}
              isOpenOnClick={true}
              triggerComponent={<QIcon_question_outline width={20} height={20} color={COLORS.GRAY500} />}
              contentComponent={t(n_weekly.freeze.tooltip)}
            />
            <div>
              <span className="Body1-16Bd">{data.summary?.used_count}</span>
              <span className="Body1-16Bd text-gray-400">/ {data.summary?.total_count}</span>
            </div>
          </div>
        </DSModal.Title>
        <DSModal.Content className="max-h-[360px] overflow-y-scroll sm:max-h-[488px]">
          <div className="mt-[16px]">
            <div className="flex h-full w-full items-center justify-between border-b-[1px] border-black py-[4px] px-[12px]">
              <div className="text-[14px] font-bold leading-snug ">{t(s_modal_weekly.header_1)}</div>
              <div className="w-[112px] text-[14px] font-bold">{t(s_modal_weekly.header_2)}</div>
            </div>
            <div>
              {data.weeks.map((week, i) => {
                return (
                  <div key={i} className="flex border-b-[1px] border-gray-100 py-[16px] text-[14px] sm:px-[12px]">
                    <div
                      className={classNames('w-[64px]', {
                        'font-medium text-gray-400': week.stage == 'past',
                        'font-bold text-black': week.stage == 'current',
                        'font-medium text-black': week.stage == 'future',
                      })}
                    >
                      {t(s_modal_weekly.week(week.week_number))}
                    </div>
                    <div
                      className={classNames('w-[256px]', {
                        'font-medium text-gray-400': week.stage == 'past',
                        'font-bold text-black': week.stage == 'current',
                        'font-medium text-black': week.stage == 'future',
                      })}
                    >
                      {week.period}
                    </div>
                    <div className="w-[112px] text-black sm:ml-[32px]">
                      {getStatus(week.achieved, week.achievement_detail)}
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
        </DSModal.Content>
      </DSModal>
    </>
  )
}

export default WeeklyLessonProgressPopup
